import React, { useEffect } from "react";

const About = () => {
  useEffect(() => {
    // Simple fade-in effect for the header image on mount
    const headerImage = document.getElementById("header-image");
    if (headerImage) {
      headerImage.classList.remove("opacity-0");
    }
  }, []);

  const teamMembers = [
    {
      name: "Karnav",
      role: "Founder/CEO",
      education: "M.S. in Computer Science (Student)",
      university: "University of Nebraska-Lincoln",
      img: "images/people/karnav.png",
      linkedin: "https://www.linkedin.com/in/karnavpatel/",
      github: "https://github.com/karnav-patel",
    },
    {
      name: "Logan",
      role: "Advisor",
      education: "Bachelors in Software Engineering",
      university: "University of Nebraska-Lincoln",
      img: "images/people/logan.jpeg",
      linkedin: "https://www.linkedin.com/in/logan-hellbusch/",
      github: "https://github.com/Logan-Hellbusch",
    },
    {
      name: "Vrushik",
      role: "Advisor",
      education: "B. Tech Computer Engineering",
      university: "CHARUSAT",
      img: "images/people/vrushik.jfif",
      linkedin: "https://www.linkedin.com/in/vrushik-patel/",
      github: "https://github.com/vrushikpatel",
    },
    // Uncomment / add more members as needed
    // {
    //   name: "Pranav",
    //   role: "Lead Mobile App Developer",
    //   education: "M.S. in Computer Science (Student)",
    //   university: "University of Nebraska-Lincoln",
    //   img: "images/people/pranav.jfif",
    //   linkedin: "https://www.linkedin.com/in/pranav-example",
    //   github: "https://github.com/pranav-example",
    // },
  ];

  return (
    <div
      style={{
        backgroundColor: "var(--bg-color)", // e.g., #f9fafb
        color: "var(--text-color)", // e.g., #1f2937
      }}
      className="min-h-screen"
    >
      {/* Header Section */}
      <header
        className="w-full pt-20 pb-16"
        style={{ background: "var(--gradient-soft)" }}
      >
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex flex-col md:flex-row items-center gap-10">
            {/* Header Text */}
            <div className="md:w-1/2">
              <span
                className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.14em] px-3 py-1.5 rounded-full mb-5"
                style={{
                  color: "var(--primary-color)",
                  backgroundColor: "var(--primary-50)",
                  border: "1px solid color-mix(in srgb, var(--primary-color) 14%, transparent)",
                }}
              >
                <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: "var(--primary-color)" }} />
                Our story
              </span>
              <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight">
                <span style={{ color: "var(--text-color)" }}>Built by educators,</span>{" "}
                <span className="ce-serif italic" style={{ color: "var(--accent-color)" }}>for educators.</span>
              </h1>
              <p className="mt-5 max-w-lg leading-relaxed text-base" style={{ color: "var(--muted-color)" }}>
                CoursEngage bridges the gap between interactive lectures and real-time feedback, designed quietly so the room stays focused on learning.
              </p>
            </div>

            {/* Header Image */}
            <div className="md:w-1/2 flex justify-center">
              <img
                id="header-image"
                src="images/people/dd.png"
                alt="Debugger Developers"
                className="rounded-2xl w-3/4 max-w-md transition-opacity duration-700 opacity-0"
                style={{ boxShadow: "var(--shadow-lg)", border: "1px solid var(--border-color)" }}
              />
            </div>
          </div>
        </div>
      </header>

      {/* Team Section */}
      <section className="py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          {/* Section Title */}
          <div className="text-center mb-12">
            <h2
              className="text-3xl sm:text-4xl font-semibold tracking-tight"
              style={{ color: "var(--text-color)" }}
            >
              Meet the <span className="ce-serif italic" style={{ color: "var(--accent-color)" }}>team.</span>
            </h2>
            <p className="mt-4 text-[var(--muted-color)] max-w-2xl mx-auto">
              A small group of engineers and educators from computer science and software engineering backgrounds.
            </p>
          </div>

          {/* Team Members Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="flex flex-col items-center rounded-2xl p-7 text-center transition-shadow"
                style={{ backgroundColor: "var(--card-bg)", border: "1px solid var(--border-color)", boxShadow: "var(--shadow-sm)" }}
              >
                {/* Member Image */}
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-32 h-32 object-cover rounded-full mb-4 shadow"
                />

                {/* Member Info */}
                <h5
                  className="text-xl font-semibold"
                  style={{ color: "var(--text-color)" }}
                >
                  {member.name}
                </h5>
                <p className="text-[var(--muted-color)] mb-2">{member.role}</p>
                <p className="text-sm mb-1" style={{ color: "var(--text-color)" }}>
                  {member.education}
                </p>
                <p className="text-xs text-[var(--muted-color)]">
                  {member.university}
                </p>

                {/* Social Links */}
                <div className="flex gap-4 justify-center mt-4">
                  {/* LinkedIn */}
                  {member.linkedin && (
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[var(--text-color)] hover:text-[var(--primary-color)] 
                                 transition-colors flex items-center gap-1"
                    >
                      <LinkedInIcon />
                      <span className="text-sm">LinkedIn</span>
                    </a>
                  )}

                  {/* GitHub */}
                  {member.github && (
                    <a
                      href={member.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[var(--text-color)] hover:text-[var(--primary-color)] 
                                 transition-colors flex items-center gap-1"
                    >
                      <GitHubIcon />
                      <span className="text-sm">GitHub</span>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

/** Inline SVG Icons for LinkedIn & GitHub **/
const LinkedInIcon = () => (
  <svg
    className="w-5 h-5"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M19 0h-14c-2.76 0-5 2.24-5 5v14c0 
      2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5v-14c0-2.76-2.24-5-5-5zm-11.75
      20h-2.5v-10h2.5v10zm-1.25-11.44c-.8 0-1.45-.66-1.45-1.47
      0-.81.65-1.47 1.45-1.47s1.45.66 1.45
      1.47c0 .81-.65 1.47-1.45 1.47zm12 11.44h-2.5v-5.6c0-1.33-.03-3.05-1.86-3.05-1.86 
      0-2.14 1.45-2.14 2.95v5.7h-2.5v-10h2.4v1.37h.04c.34-.64 
      1.16-1.31 2.4-1.31 2.57 0 3.05 1.7 3.05 3.91v6.03z" />
  </svg>
);

const GitHubIcon = () => (
  <svg
    className="w-5 h-5"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M12 .297c-6.63 0-12 5.373-12 
      12 0 5.303 3.438 9.8 8.205
      11.387.6.113.82-.258.82-.577
      0-.285-.01-1.04-.016-2.04-3.338.724-4.042-1.61-4.042-1.61-.546-1.387-1.333-1.757-1.333-1.757-1.09-.745.084-.73.084-.73 
      1.205.084 1.84 1.236 1.84 1.236
      1.07 1.835 2.807 1.304 3.492.997.108-.776.417-1.304.76-1.604-2.665-.305-5.466-1.333-5.466-5.93 
      0-1.31.467-2.38 1.235-3.22-.124-.303-.535-1.523.117-3.176 
      0 0 1.008-.322 3.301 1.23.96-.267 
      1.98-.399 3-.405 1.02.006 2.04.138 
      3 .405 2.292-1.552 3.3-1.23 
      3.3-1.23.653 1.653.242 2.873.118 
      3.176.77.84 1.235 1.91 1.235 
      3.22 0 4.61-2.805 5.625-5.476 
      5.92.43.372.81 1.102.81 2.222 
      0 1.606-.014 2.904-.014 3.301 
      0 .319.215.694.825.576 4.765-1.589 
      8.2-6.086 8.2-11.386 
      0-6.627-5.373-12-12-12z" />
  </svg>
);

export default About;
